<template>
  <div>
    <modal-confirmacion
      :playerSelected="playerSelected"
      :action="accionAlterna"
      :movimiento="movimientoDelete"
      @eliminado="showMensajeEliminado($event)"
      @eliminadoPase="showMensajeEliminadoPase($event)"
      @revisado="showMensajeRevisado"
      @recargar="recargaUdpate($event)"
    ></modal-confirmacion>
    <add-new-player
      :playerSelected="playerSelected"
      :playerAuxiliar="playerAuxiliar"
      :posiciones="listPositions"
      :tiposAdicional="listTiposAdicionales"
      :campeonatoSeleccionado="campeonatoSeleccionado"
      :listCategorias="listCategoriasAdmin"
      :instituciones="listInstitutions"
      @recargar="recargaUdpate($event)"
      @recargarHistorial="getJugadores($event)"
      @updateFacial="actualizaFacialVarios"
    ></add-new-player>
    <div
      v-if="USER().cliente.show_control_play === '0'"
      class="misc-inner p-2 p-sm-3"
    >
      <div class="w-100 text-center">
        <h2 class="mb-1">
          Tú no estas autorizado! 🔐
        </h2>
        <p class="mb-2">
          No tienes los permisos para ver esta página. !!
        </p>
        <b-img
          fluid
          :src="require('@/assets/images/pages/not-authorized.svg')"
          alt="Pagina no autorizada"
          style="width:50%"
        />
      </div>
    </div>
    <div v-else>
      <b-tabs pills class="m-0" v-model="tabModel">
        <b-tab title="Delegados" :active="false" @click="resetRevision">
          <b-card no-body>
            <div class="m-1">
              <b-row>
                <b-col md="3">
                  <v-select
                    :options="listCampeonatos"
                    placeholder="Selecciona Campeonato"
                    :clearable="false"
                    v-model="campeonatoSeleccionado"
                    @input="changeCampeonato"
                  />
                </b-col>
                <b-col
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                  <b-dropdown variant="link" no-caret toggle-class="p-0" right>
                    <template #button-content>
                      <b-button
                        v-b-tooltip.hover.v-primary
                        title="Agregar Delegados"
                        variant="flat-primary"
                        class="btn-icon"
                        size="sm"
                      >
                        <feather-icon size="22" icon="UserPlusIcon" />
                      </b-button>
                    </template>
                    <b-dropdown-item @click="createPlayer"
                      ><feather-icon icon="PlusIcon" />
                      <span class="align-middle ml-50"
                        >Individual</span
                      ></b-dropdown-item
                    >
                  </b-dropdown>
                </b-col>
                <b-col md="2">
                  <b-badge variant="info">
                    <feather-icon icon="UsersIcon" class="mr-25" />
                    <span>Total : {{ listPlayersFilter.length }}</span>
                  </b-badge>
                </b-col>
                <b-col
                  cols="12"
                  md="12"
                  class="d-flex align-items-center justify-content-start mt-1 mb-md-0"
                >
                  <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="Buscar..."
                  />
                </b-col>
              </b-row>
            </div>
            <b-overlay :show="showLoading" rounded="sm">
              <b-row v-if="listPlayersFilter.length != 0" class="ml-1 mb-1">
                <!-- <b-col md="2" style="text-align:right; ">
                <vue-excel-xlsx
                  :data="listPlayersFilter"
                  :columns="columns"
                  :file-name="'listado'"
                  :file-type="'xlsx'"
                  :sheet-name="'sheetname'"
                  class="excel"
                >
                  Exportar Excel
                </vue-excel-xlsx>
              </b-col> -->
              </b-row>
              <b-table
                ref="refInvoiceListTable"
                :fields="tableColumns"
                :items="listPlayersFilter"
                primary-key="id"
                show-empty
                responsive
                small
                empty-text="No se encontraron datos"
                class="position-relative pl-1 pr-1"
                :sticky-header="'calc(100vh - 380px)'"
                :no-border-collapse="true"
              >
                <template #cell(jugador)="data">
                  <b-media vertical-align="center">
                    <template #aside>
                      <div style="display:grid">
                        <b-avatar
                          size="32"
                          :style="
                            !data.item.have_face ? 'border:2px solid red' : ''
                          "
                          :src="data.item.foto_jug"
                          :text="avatarText(data.item.nombres)"
                        />
                        <small v-if="data.item.from_delegado" class="new"
                          >New</small
                        >
                        <template>
                          <b-button
                            v-if="
                              (USER().rol === ROLES.SUPER ||
                                USER().rol === ROLES.ADMIN) &&
                                data.item.have_face === false
                            "
                            v-b-tooltip.hover.v-primary
                            title="Obtener Id Facial"
                            variant="outline-primary"
                            class="btn-icon"
                            style="height:10px;line-height:0;margin-top:2px"
                            size="sm"
                            @click="updateFacialId(data.item)"
                          >
                            <span style="font-size:10px">F.Id</span>
                          </b-button>
                        </template>
                      </div>
                    </template>
                    <span class="font-weight-bold d-block text-nowrap">
                      {{ data.item.apellidos }} {{ data.item.nombres }}
                    </span>
                    <small class="text-muted">{{
                      data.item.ci_pasaporte
                    }}</small>
                  </b-media>
                </template>
                <!-- Column: Actions -->
                <template #cell(acciones)="data">
                  <div class="text-nowrap">
                    <feather-icon
                      :id="`invoice-row-${data.item.id}-send-icon`"
                      icon="EditIcon"
                      class="cursor-pointer"
                      size="16"
                      @click="getDataPlayer(data.item)"
                    />
                    <feather-icon
                      v-if="
                        USER().rol === ROLES.SUPER || USER().rol === ROLES.ADMIN
                      "
                      :id="`invoice-row-${data.item.id}-preview-icon`"
                      icon="Trash2Icon"
                      size="16"
                      class="mx-1"
                      @click="showModalConfirmacion(data.item, 'delete')"
                    />
                  </div>
                </template>
              </b-table>
            </b-overlay>
          </b-card>
        </b-tab>
        <b-tab title="Control">
          <control :list-campeonatos="listCampeonatos"></control>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {
  BButton,
  BCard,
  VBTooltip,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BMedia,
  BAvatar,
  // BTooltip,
  BBadge,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BTabs,
  BTab,
  BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { avatarText } from '@core/utils/filter'
import {
  ref,
  onMounted,
  watch,
  // watchEffect,
  // reactive,
  computed,
  // onBeforeMount,
  //  ccc
} from '@vue/composition-api'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useInscription from './useInscription'
import AddNewPlayer from './AddDelegado.vue'
import {
  // URL,
  USER,
  ROLES,
  ESTADO_JUGADOR,
  // INSERT_DATA_PLAYER,
  // INSERT_DATA_HISTORY_PLAYER,
  // UPDATE_DATA_PLAYER,
} from '../../utils/variables'
import ModalConfirmacion from './ModalConfirmacion.vue'
import Control from './Control.vue'
// eslint-disable-next-line
// const Draggabilly = require('draggabilly')

export default {
  components: {
    BCard,
    vSelect,
    BButton,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    // BTooltip,
    BBadge,
    AddNewPlayer,
    BOverlay,
    BDropdown,
    BDropdownItem,
    ModalConfirmacion,
    BTabs,
    BTab,
    Control,
    BImg,
    // AddEx,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    // const listJugadores = ref([])
    // const refP = ref(null)
    const dataRevision = ref({ apodo: '', alias_equipo: '' })
    const playerSelected = ref({ dataCategoria: { facialWeb: false } })
    const playerAuxiliar = ref({})
    const accionAlterna = ref('')
    const movimientoDelete = ref('')
    const tabModel = ref(0)
    const campeonatoSeleccionado = ref(null)
    const listCampeonatos = ref([])
    // const draggieFoto = new Draggabilly('.dragDiv')
    // draggieFoto.on('dragMove', function() {
    //   console.log('dragMove')
    // })
    // const modoRevision = ref(store.state.someVariables.activateRevision)

    // watch(modoRevision, data => {
    //   console.log('en inscriptions', data)
    // })
    const {
      tableColumns,
      listJugadores,
      getCategoriasEditar,
      changeCategoria,
      getJugadores,
      searchQuery,
      refInvoiceListTable,
      listPlayersFilter,
      playerData,
      getPositionsDiscipline,
      listPositions,
      listTiposAdicionales,
      listCategoriasAdmin,
      INSERT_DATA_PLAYER,
      UPDATE_DATA_PLAYER,
      showLoading,
      insertSolicitudRevision,
      // updateSolicitudRevision,
      salirRevision,
      categoriaSeleccionada,
      printCarnets,
      selectedPrint,
      getTotal,
      totalCalificados,
      totalRevisados,
      totalInscritos,
      totalInactivos,
      updateFacialId,
      getInstituciones,
      listInstitutions,
      // playerSelected,
    } = useInscription()
    function rowClass(item) {
      if (!item) return '' // 🔥 evita null / undefined

      return !item.is_activo ? 'row-disabled' : ''
    }
    function actualizaFacialVarios() {
      // console.log(playerSelected.value.id_jugador)
      const found = listPlayersFilter.value.findIndex(
        // eslint-disable-next-line
        element => element.id_jugador === playerSelected.value.id_jugador,
      )
      listPlayersFilter.value[found].have_face = true
      playerSelected.value.have_facial = true
    }
    function showModalConfirmacion(item, action) {
      playerSelected.value = item
      // console.log(playerSelected.value)
      accionAlterna.value = action
      movimientoDelete.value = `Elimina Delegado con idHistorial ${playerSelected.value.id_historial_delegado}`

      store.commit('someVariables/UPDATE_SHOW_CONFIRMACION_DELEGADO', true)
    }

    function showMensajeEliminado() {
      getJugadores(campeonatoSeleccionado.value.value)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ELIMINADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }

    function showMensajeRevisado() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'REVISION EXITOSA',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
      salirRevision()
    }

    function getDataPlayer(item) {
      // console.log(item)
      // item.posicionAuxiliar = {
      //   value: item.id_posicion,
      //   label: item.posicion,
      // }
      // item.posicion = item.posicionAuxiliar
      item.validations = playerData.validations
      playerSelected.value = { ...item }
      playerAuxiliar.value = { ...item }
      // console.log(playerSelected.value)
      store.commit('someVariables/UPDATE_ACTION_DELEGADO', UPDATE_DATA_PLAYER)
      store.commit('someVariables/UPDATE_SHOW_NEW_DELEGADO', true)
    }

    // watch(modoRevision, newValue => {
    //   if (newValue) {
    //     getJugadores('2')
    //   }
    //   console.log('modo revision', newValue)
    //   console.log(categoriaAdmin)
    // })
    function recargaUdpate(idEquipo) {
      getJugadores(idEquipo)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'JUGADOR actualizado exitosamente',
            icon: 'CheckIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
    }

    // const showNewPlayer = AddNewPlayer
    function onRowSelected(items) {
      // let [item] = items
      // console.log(items)
      selectedPrint.value = items
    }
    // function imprimirCarnets() {
    //   console.log(listPlayersFilter.value)
    // }

    function openInputFile(elemId) {
      const elem = document.getElementById(elemId)
      if (elem && document.createEvent) {
        const evt = document.createEvent('MouseEvents')
        evt.initEvent('click', true, false)
        elem.dispatchEvent(evt)
      }
    }

    function createPlayer() {
      store.commit('someVariables/UPDATE_SHOW_NEW_DELEGADO', true)
      store.commit('someVariables/UPDATE_ACTION_DELEGADO', INSERT_DATA_PLAYER)
      playerSelected.value = { ...playerData }
      // console.log(playerSelected)
      // console.log(playerData)
    }

    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    function changeCampeonato() {
      getJugadores(campeonatoSeleccionado.value.value)
    }

    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
          id_torneo: element.id_torneo,
          activo: element.activo,
        }
        salida.value.push(obj)
      })
    }
    watch(cambioTorneo, () => {
      categoriaSeleccionada.value = {
        label: 'Seleccione Equipo',
        isInReview: false,
      }
      listJugadores.value = []
      playerData.id_equipo = ''

      campeonatoSeleccionado.value = null
      listCampeonatos.value = []
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
    })
    // onBeforeMount(() => {
    //   console.log('unbeforeee')
    //   this.$router.push('/')
    // })
    onMounted(() => {
      // console.log(USER())
      getInstituciones(
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      )
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
      const campActivo = listCampeonatos.value.find(
        // eslint-disable-next-line
        element => element.activo === 's',
      )
      campeonatoSeleccionado.value = campActivo
      getJugadores(campActivo.value)
      // console.log(refP.value)
    })

    function resetRevision() {
      categoriaSeleccionada.value = {
        label: 'Seleccione Equipo',
        isInReview: false,
      }
      // listJugadores.value = []
      playerData.id_equipo = ''
    }

    return {
      tableColumns,
      listJugadores,
      getCategoriasEditar,
      changeCategoria,
      getJugadores,
      avatarText,
      searchQuery,
      refInvoiceListTable,
      listPlayersFilter,
      onRowSelected,
      // refP,
      createPlayer,
      playerSelected,
      getPositionsDiscipline,
      listPositions,
      listTiposAdicionales,
      getDataPlayer,
      INSERT_DATA_PLAYER,
      UPDATE_DATA_PLAYER,
      listCategoriasAdmin,
      USER,
      ROLES,
      ESTADO_JUGADOR,
      openInputFile,
      playerData,
      showLoading,
      insertSolicitudRevision,
      salirRevision,
      dataRevision,
      // updateSolicitudRevision,
      categoriaSeleccionada,
      showModalConfirmacion,
      showMensajeEliminado,
      printCarnets,
      recargaUdpate,
      accionAlterna,
      getTotal,
      totalCalificados,
      totalRevisados,
      totalInscritos,
      totalInactivos,
      tabModel,
      resetRevision,
      showMensajeRevisado,
      playerAuxiliar,
      movimientoDelete,
      updateFacialId,
      actualizaFacialVarios,
      rowClass,
      listCampeonatos,
      campeonatoSeleccionado,
      listInstitutions,
      changeCampeonato,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
// .b-table-sticky-header {
//     overflow-y: auto;
//     max-height: 60vh;
// }
.new {
  font-size: 9px;
  text-align: center;
  background-color: rgb(230, 36, 10);
  color: white;
  margin-top: 2px;
  border-radius: 10px;
}
.excel {
  color: #ede5e5;
  background-color: rgb(156, 21, 102);
  border: 4px;
  border-radius: 4px;
  font-size: 11px;
  padding: 2px 4px 2px 5px;
  margin-right: 12px;
  font-weight: bold;
}
.row-disabled {
  background-color: #f2f2f2 !important;
  color: #9e9e9e;
  pointer-events: none; /* 🔥 bloquea clics */
  opacity: 0.7;
}
.camp-activo {
  background: #00ff31;
  border-radius: 3px;
  padding: 6px;
  top: 5px;
  position: relative;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: bolder;
}
.camp-anterior {
  background: #ffee00;
  border-radius: 3px;
  padding: 6px;
  top: 5px;
  position: relative;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: bolder;
}
</style>
